const powerSuppliers = [
  { name: 'ConEd', value: 'ConEd' },
  { name: 'LADWP', value: 'LADWP' },
];

export default powerSuppliers;
